module.exports = __webpack_public_path__ + "static/media/mundo.433e3b22.png";


//////////////////
// WEBPACK FOOTER
// ./src/Img/mundo.png
// module id = 289
// module chunks = 0